/*eslint-disable*/
export default form => {
  $(document).ready(() => {
    let $form = $(form)
    let $successMessage = $('.tee-signup-form-message')
    let url = 'https://script.google.com/macros/s/AKfycbyKzvygNXnQQ2Vp0XrRgyrkTtLqgD3aPxclVtMW2iZJyOqsFBNv/exec'

    $form.on('submit', e => {
      e.preventDefault()
      $('.tee-signup-form-submit').css({
        'opacity': '0',
        'visibility': 'hidden'
      })
      $('.tee-signup-form-loader').css({
        'opacity': '1',
        'visibility': 'visible'
      })
      $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json',
        data: serializeJqueryObject($form),
        success: data => {
          console.log('success data: ', data)
          $successMessage.addClass('success')
          $form.addClass('hide')
          $('.tee-signup-form-submit').css({
            'opacity': '1',
            'visibility': 'visible'
          })
          $('.tee-signup-form-loader').css({
            'opacity': '0',
            'visibility': 'hidden'
          })
        },
        error: error => {
          console.error(error)
        }
      })
    })
  })

  const serializeJqueryObject = $form => {
    let obj = {}
    let array = $form.serializeArray()
    array.forEach((entry, idx) => {
      if (obj[entry.name]) {
        if (!obj[entry.name].push) obj[entry.name] = [obj[entry.name]]
        obj[entry.name].push(entry.value || '')
      } else obj[entry.name] = entry.value || ''
    })
    return obj
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/the-every-edit-signup-form.js